export const normalizeTemplateCreateInput = template => {
  const result = { ...template };
  ['tags', 'tagsFa'].forEach(key => {
    if (result[key] !== undefined) {
      const values = Array.isArray(result[key]) ? result[key] : String(result[key]).replace(/،/g, ',').split(',');
      result[key] = values.map(value => String(value).trim()).filter(Boolean);
    }
  });
  if (typeof result.description === 'string' && !result.description.trim()) delete result.description;
  return result;
};
